<template>
    <autocomplete
        :search="search"
        class="autocomplete"
        :placeholder="resolvedLabel"
        ref="field"
        @submit="onSubmit"
        :get-result-value="getResultValue"
        :debounce-time="searchFn ? 250 : 0"
        @update="onUpdate"
    >
        <template #result="{ result, props }">
            <li v-bind="props" class="autocomplete-result">
                <slot>
                    {{ result.label }}
                </slot>
            </li>
        </template>
    </autocomplete>
</template>
<script>
import Autocomplete from "@trevoreyre/autocomplete-vue";
export default {
    name: "simple-autocomplete",
    props: {
        label: {
            type: String,
            default: "",
        },
        value: {
            type: Object,
            default: () => ({ label: "", value: "" }),
        },
        options: {
            type: Array,
            default: [],
        },
        // Optional async source: (input) => Promise<[{ value, label }]>.
        // When set, suggestions come from it instead of `options`.
        searchFn: {
            type: Function,
            default: null,
        },
    },
    components: {
        Autocomplete,
    },
    watch: {
        value: {
            immediate: true,
            handler(newV) {
                this.$nextTick(() => {
                    if (this.$refs.field) {
                        this.$refs.field.setValue(newV);
                    }
                });
            },
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        getResultValue(result) {
            return result.label;
        },
        search(input) {
            if (this.searchFn) {
                return input && input.trim() ? this.searchFn(input.trim()) : [];
            }
            return this.options.filter((o) =>
                o.label.toLowerCase().includes(input.toLowerCase()),
            );
        },

        onSubmit(result) {
            if (result.value) {
                this.$emit("input", result.value);
            }
        },

        onUpdate() {
            if (this.$refs.field.value !== undefined) {
                this.$emit("input", this.$refs.field.value);
            }
        },
    },
    computed: {
        resolvedLabel() {
            return this.label || this.t("inputs-select-search_placeholder");
        },
    },
};
</script>
<style lang="less" scoped>
.autocomplete-result {
    background: #fff;
}
::v-deep {
    .autocomplete-input {
        display: block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition:
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }

    [data-position="above"] .autocomplete-result-list {
        top: initial !important;
    }
    .autocomplete-result-list {
        position: absolute;
        background: #fff;
        color: #333;
        left: 0;
        width: 100%;
        padding: 0;
        top: 100%;
        margin-top: 0;
        text-align: left;
        border-radius: 4px;
        z-index: 10;
        cursor: default;
        border: 1px solid #ddd;
        li {
            margin: 0;
            list-style: none;
            padding: 5px;
            font-size: 12px;
            &:hover {
                background: #f5f5f5;
            }
        }
    }
}
</style>
